import styled from "styled-components";

const HeaderSection = styled.header`
  display: flex;
  width: fit-content;
  flex-direction: column;
`;

const HeaderText = styled.p`
  color: #123559;
  font-family: "Prompt";
  font-weight: ${(props: { fontSize: string; weight: string }) => props.weight};
  font-size: ${(props: { fontSize: string; weight: string }) => props.fontSize};
  margin: 0;
  text-align: left;
`;

interface HeaderProps {
  title: string;
  subheader: string;
}
const HeaderComponent = (props: HeaderProps) => {
  return (
    <HeaderSection>
      <HeaderText weight="bold" fontSize="36px">
        {props.title}
      </HeaderText>
      <HeaderText weight="regular" fontSize="24px">
        {props.subheader}
      </HeaderText>
    </HeaderSection>
  );
};

export default HeaderComponent;
